export default __webpack_public_path__ + "static/IMDA_SME_Medium-67906dac4bb9449dd8804a9e28c5d2ad.webp";